import { Reveal, Stagger, Interactive } from "@/motion";
import { Section } from "@/components/Section";
import { PRODUCTS } from "@/data/products";

export function ProductRange() {
  return (
    <Section id="shop" labelledBy="shop-title" tone="surface">
      <Reveal as="div" className="section__head" distance={16}>
        <p className="eyebrow">The range</p>
        <h2 id="shop-title" className="section__title">
          Four pieces. No filler.
        </h2>
      </Reveal>

      <Stagger as="ul" className="grid" interval={0.08} delay={0.05}>
        {PRODUCTS.map((p) => (
          <Stagger.Item as="li" key={p.id} distance={24}>
            <Interactive as="article" className="card" lift={4} scale={1}>
              <div className="card__media">
                <img
                  src={p.cardImage}
                  alt={p.alt}
                  loading="lazy"
                  decoding="async"
                  width={600}
                  height={720}
                />
              </div>
              <p className="eyebrow card__eyebrow">{p.eyebrow}</p>
              <h3 className="card__title">{p.name}</h3>
              <p className="card__blurb">{p.blurb}</p>
              <p className="card__price">{p.price}</p>
            </Interactive>
          </Stagger.Item>
        ))}
      </Stagger>
    </Section>
  );
}
